import { render, staticRenderFns } from "./globalStrategy1.vue?vue&type=template&id=4c9d9839&scoped=true&"
import script from "./globalStrategy1.vue?vue&type=script&lang=js&"
export * from "./globalStrategy1.vue?vue&type=script&lang=js&"
import style0 from "./globalStrategy1.vue?vue&type=style&index=0&id=4c9d9839&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d9839",
  null
  
)

export default component.exports